import SideMenu from '@/containers/side-menu/SideMenu.vue';
import CameraMonitor from '@/pages/camera-monitor/CameraMonitor.vue';

export default {
  path: '/camera-monitor',
  name: 'CameraMonitor',
  components: {
    mainContent: CameraMonitor,
    mainMenu: SideMenu,
  },
  meta: {
    role: {
      sectorId: 'dashboard',
    },
    breadcrumb: {
      title: 'Monitor de Cameras',
      paths: [{ title: 'Monitor de Cameras' }],
    },
  },
};
